import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

const ButtonSecondary = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-btn-secondary', ...classNames]} />
);

ButtonSecondary.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonSecondary;
